var React = require('react');

function TwitterIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 1.5H38C42.7002 1.5 46.5 5.29574 46.5 9.96575V37.8698C46.5 42.5398 42.7002 46.3356 38 46.3356H10C5.30157 46.3356 1.5 42.5396 1.5 37.8698V9.96575C1.5 5.29594 5.30157 1.5 10 1.5Z","stroke":"white","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M9.07314 9.9H8.87348L8.99306 10.0599L20.5258 25.4803L8.92661 38.0109L8.77117 38.1788H9H11.6233H11.667L11.6966 38.1467L21.8197 27.2106L29.9929 38.1387L30.0229 38.1788H30.073H39H39.1997L39.0801 38.0189L26.8956 21.7274L37.6882 10.0679L37.8436 9.9H37.6148H34.9915H34.9478L34.9181 9.93207L25.6017 19.997L18.0803 9.94011L18.0503 9.9H18.0002H9.07314ZM31.0907 36.0462L13.1305 12.0323H16.9819L34.942 36.0462H31.0907Z","fill":"white","stroke":"white","strokeWidth":"0.2","key":1})]);
}

TwitterIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = TwitterIcon;

TwitterIcon.default = TwitterIcon;
